import { IMediated, IRunnable, IQuery, ITypedQuery, mediated_data_types } from 'core-ts-types';
import { Query } from '../types/query';
import * as _4 from 'lodash';

/**
 * mediate updates on Datasources or Usersources in Commands to keep Metasources and Queries fresh
 */
export class ORM {
  public static METASOURCE_KEY = `__metasource__`;
  public static QUERY_KEY = `__queries__`;

  private static __executionHistory: Set<IMediated> = new Set();
  private static __nothingRan: (IQuery | ITypedQuery<any>)[] = [];
  private static __on: boolean = true;

  static get on() {
    return this.__on;
  }

  static set on(_on: boolean) {
    const wasOff = !ORM.__on;

    this.__on = _on;
    if (wasOff && _on) {
      ORM.run();
    }
  }

  /**
   *
   * @param sources all sources we updated in a command
   * @returns list of all queries
   */
  static run(...sources: (IMediated | mediated_data_types)[]): (IQuery | ITypedQuery<any>)[] {
    if (!this.__on) {
      return this.__nothingRan;
    }

    const updateSources = [...sources, ...this.marked];
    // FIXME remove mediated_data_types as a supported type, so we can take away the any
    return this.clearMarked()
      ._runMetas(updateSources as any)
      ._runQueries(updateSources as any);
  }

  /**
   * @deprecated create a Query or use Query#registerQuery
   * @param query query that needs to execute in response to a command
   * @param sources {Array} all sources
   */
  static registerQuery(query: IQuery | ITypedQuery<any>, ...sources: (IMediated | mediated_data_types)[]): typeof ORM {
    Query.registerQuery(query, ...sources);
    return this;
  }

  /**
   *
   * @param sources all sources we updated in a command
   * @returns list of all queries
   */
  protected static _runQueries(sources: IMediated[]): (IQuery | ITypedQuery<any>)[] {
    return _4.map(
      ORM.__calculateUnique(sources, this.QUERY_KEY),
      (query: IQuery | ITypedQuery<any>): IQuery | ITypedQuery<any> => {
        return query.run();
      }
    );
  }

  protected static _runMetas(sources: IMediated[]): typeof ORM {
    _4.each(ORM.__calculateUnique(sources, this.METASOURCE_KEY), (metasource) => {
      metasource.run();
    });

    return this;
  }

  private static __calculateUnique(sources: IMediated[], trackedEntity: string): IRunnable[] {
    return _4.uniq(_4.compact(_4.flatten(_4.map(sources, trackedEntity)))) as IRunnable[];
  }

  static get marked(): IMediated[] {
    return Array.from(ORM.__executionHistory);
  }

  static clearMarked(): typeof ORM {
    this.__executionHistory.clear();
    return this;
  }

  static mark(mediated: IMediated): typeof ORM {
    this.__executionHistory.add(mediated);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-orm/src/engine/orm.ts